import { keepPreviousData, useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import type { MetricPeriod, Overview } from '@manaro/contracts'
import { queryKeys } from '@/shared/api/query-keys.ts'
import { fetchOverview } from './api.ts'

export function useOverview(period: MetricPeriod) {
  return useQuery({
    queryKey: queryKeys.overview(period),
    queryFn: ({ signal }) => fetchOverview(period, { signal }),
    placeholderData: keepPreviousData,
    staleTime: 5 * 60 * 1000,
  })
}

export function useRefreshOverview(period: MetricPeriod) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: () => fetchOverview(period, { refresh: true }),
    onSuccess: (data: Overview) => queryClient.setQueryData(queryKeys.overview(period), data),
  })
}
